import {Act} from '@gongxigames/framework/slotV2/fsm/acts/Act';
import {ListenerActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/ListenerActDecorator';
import {consoleLogger} from '@gongxigames/framework/core';

/**
 * ListenerAct class is used only with ListenerActDecorator.
 */
export class ListenerAct extends Act {
    private _decoratorAct?: ListenerActDecorator;

    public execute(onExecuted: () => void): void {
        if (this._decoratorAct) {
            consoleLogger.log('>>>>ListenerAct started: ', this._decoratorAct.getName());
            this._decoratorAct.executeSkipOnRoot = this.executeSkipOnRoot;
            this._decoratorAct.listen();
        }

        return super.execute(onExecuted);
    }

    public async skip(): Promise<void> {
        this.removeAllEventListeners();
    }

    public set decoratorAct(value: ListenerActDecorator) {
        this._decoratorAct = value;
    }

    public removeAllEventListeners(): void {
        if (this._decoratorAct) {
            consoleLogger.log('>>>>ListenerAct finished:  ', this._decoratorAct.getName());
        }
        this._decoratorAct?.removeAllListeners();
    }
}